import BaseApi from './base';

class MetaInfoApi extends BaseApi {
  getVersion() {
    return this.request.get('/meta-info/version');
  }
}

export default new MetaInfoApi();
